import React from "react";
import { observer } from "mobx-react";
import { Button } from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import { SearchProfileMultiSelector } from "@containers/VirtualSelector/SearchProfileSelector/SearchProfileMultiSelector";
import { CustomerProfileStore } from "../CustomerProfileStore";
import { SearchProfileType } from "@bonliva-crm/graphql";

type Props = {
  store: CustomerProfileStore;
};

export const SearchProfile = observer((props: Props) => {
  const { store } = props;

  return (
    <div style={{ padding: 16 }}>
      <SearchProfileMultiSelector
        type={SearchProfileType.Consultants}
        onChange={store.handleChangeSearchProfiles}
        defaultValue={store.searchProfiles}
        selected={store.selectedSearchProfiles}
      />

      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
        <Button
          variant={"contained"}
          disabled={!store.selectedSearchProfiles}
          color="primary"
          onClick={store.submitChangeSearchProfiles}
        >
          {locale.Save}
        </Button>
      </div>
    </div>
  );
});
